import { Interface } from '@ethersproject/abi'
import BUY_BACK_AND_BURN_ABI from './BuyBackAndBurn.json'

const BUY_BACK_AND_BURN_INTERFACE = new Interface(BUY_BACK_AND_BURN_ABI)

export default BUY_BACK_AND_BURN_INTERFACE
export { BUY_BACK_AND_BURN_ABI }
